import { Mail } from "lucide-react";
import { MarketingShell } from "@/components/MarketingShell";

const SUPPORT_EMAIL = "support@helloprobe.com";

export default function ContactPage() {
  return (
    <MarketingShell>
      <section className="bg-white">
        <div
          className="max-w-3xl mx-auto px-4 sm:px-6 py-20 lg:py-28"
          data-testid="contact-page"
        >
          <p className="label-caps text-[#3B82F6]">Contact</p>
          <h1
            data-testid="contact-headline"
            className="font-['Geist'] font-semibold text-4xl sm:text-5xl tracking-tight mt-2 leading-[1.05] text-[#0F172A]"
          >
            Contact us.
          </h1>
          <p className="mt-5 text-base text-[#4B5563] leading-relaxed max-w-xl">
            Questions, feedback, enterprise enquiries or trouble with a test run — we&apos;d
            love to hear from you.
          </p>

          {/* Primary support card */}
          <a
            href={`mailto:${SUPPORT_EMAIL}`}
            data-testid="contact-support-card"
            className="mt-12 group flex flex-col sm:flex-row sm:items-center justify-between gap-4 border border-[#E5E7EB] hover:border-[#3B82F6] bg-white rounded-xl p-6 sm:p-8 transition-all duration-150 hover:shadow-[0_8px_28px_-12px_rgba(59,130,246,0.25)]"
          >
            <div className="flex items-start gap-4">
              <div className="flex items-center justify-center w-11 h-11 rounded-lg bg-[#3B82F6]/10 text-[#3B82F6] shrink-0">
                <Mail size={18} />
              </div>
              <div>
                <p className="font-mono text-[10px] tracking-[0.22em] uppercase text-[#64748B]">
                  Support · sales · everything else
                </p>
                <p
                  data-testid="contact-support-email"
                  className="mt-1 font-['Geist'] font-semibold text-xl sm:text-2xl tracking-tight text-[#0F172A] group-hover:text-[#3B82F6] transition-colors"
                >
                  {SUPPORT_EMAIL}
                </p>
              </div>
            </div>
            <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#64748B] group-hover:text-[#3B82F6] transition-colors">
              Send email →
            </span>
          </a>

          {/* Secondary info */}
          <div className="mt-10 grid sm:grid-cols-2 gap-4">
            <div className="border border-[#E5E7EB] bg-white rounded-xl p-6" data-testid="contact-response-time">
              <p className="font-mono text-[10px] tracking-[0.22em] uppercase text-[#64748B]">
                Response time
              </p>
              <p className="mt-2 text-sm text-[#374151] leading-relaxed">
                We reply to most enquiries within one business day. Enterprise customers on a
                paid plan are prioritised.
              </p>
            </div>
            <div className="border border-[#E5E7EB] bg-white rounded-xl p-6" data-testid="contact-status">
              <p className="font-mono text-[10px] tracking-[0.22em] uppercase text-[#64748B]">
                Already a customer?
              </p>
              <p className="mt-2 text-sm text-[#374151] leading-relaxed">
                Sign in to your workspace to file a ticket directly from the dashboard for
                faster routing.
              </p>
            </div>
          </div>
        </div>
      </section>
    </MarketingShell>
  );
}
